import type { ContactContent } from "../content/contact";
import { Editable } from "../edit";
import { useSiteLink } from "../link";

// Admin-preview renderer for the Contact page: the hero + contact details are
// click-to-editable; the form is a static, inert mock of the real one (which
// the website owns — validation, Turnstile and submission are code, not
// content). The copy here edits in context without touching the live form.
export function ContactSections({ content }: { content: ContactContent }) {
  const Link = useSiteLink();
  const c = content;
  return (
    <>
      <section className="hero page-hero">
        <div className="wrap">
          <div className="hero-copy">
            <Editable as="p" className="eyebrow" path="hero.eyebrow" value={c.hero.eyebrow} />
            <Editable as="h1" path="hero.heading" value={c.hero.heading} />
            <Editable as="p" className="lede" path="hero.lede" value={c.hero.lede} singleLine={false} />
          </div>
        </div>
      </section>

      <section className="section" style={{ paddingTop: 0 }}>
        <div className="wrap form-grid">
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="row2">
              <div className="field">
                <label>Full name</label>
                <input disabled />
              </div>
              <div className="field">
                <label>Work email</label>
                <input disabled />
              </div>
            </div>
            <div className="row2">
              <div className="field">
                <label>Company or organization</label>
                <input disabled />
              </div>
              <div className="field">
                <label>
                  Phone <span className="opt">(optional)</span>
                </label>
                <input disabled />
              </div>
            </div>
            <div className="row2">
              <div className="field">
                <label>Country</label>
                <input disabled placeholder="Start typing a country" />
              </div>
              <div className="field">
                <label>You are</label>
                <input disabled placeholder="Select one" />
              </div>
            </div>
            <div className="field">
              <label>
                Monthly messages today, SMS or other channels <span className="opt">(optional)</span>
              </label>
              <input disabled placeholder="Select a range" />
            </div>
            <div className="field">
              <label>What would you like to do on WhatsApp?</label>
              <textarea disabled rows={3} />
            </div>
            <div className="field">
              <label className="consent">
                <input type="checkbox" disabled />
                <span>
                  I agree that Quintara may use these details to respond to my enquiry, as described in the{" "}
                  <Link to="/privacy">privacy policy</Link>.
                </span>
              </label>
            </div>
            <div>
              <button className="btn btn-primary" type="button" disabled>
                Send message
              </button>
            </div>
          </form>

          <aside className="contact-side">
            <dl>
              <div>
                <dt>Email</dt>
                <dd>
                  <Editable as="span" path="side.email" value={c.side.email} />
                </dd>
              </div>
              <div>
                <dt>Phone</dt>
                <dd>
                  <Editable as="span" path="side.phone" value={c.side.phone} />
                </dd>
              </div>
              <div>
                <dt>Office</dt>
                <dd>
                  <Editable as="span" path="side.officeName" value={c.side.officeName} />
                  <br />
                  <Editable as="span" path="side.officeLocation" value={c.side.officeLocation} />
                </dd>
              </div>
            </dl>
            <Editable as="p" className="small muted" path="side.note" value={c.side.note} singleLine={false} />
          </aside>
        </div>
      </section>
    </>
  );
}
